import { TextField, Typography, InputAdornment, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { createFactory, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import { useLocation } from 'react-router-dom';
import CloseImage from '../../assets/ic_close.png';
import ImageUploader from 'react-images-upload';
import { format } from 'date-fns';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';
import { TimePicker, KeyboardDateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import NumberFormat from 'react-number-format';
import Constant from '../../library/Constant';
import { SignalCellularNullSharp, Visibility } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import Send from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';

const lib = ["places"];

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}


export default function DetailHistoryEmergency(props) {
    const history = useHistory()
    const location = useLocation()
    const [ID, setID] = useState("")
    // const [tglOrder, setTglOrder] = useState(new Date());
    const [tglBooking, setTglBooking] = useState(new Date());
    const [jamBooking, setJamBooking] = useState("");
    const [pemesan, setPemesan] = useState("")
    const [noHP, setNoHP] = useState("")
    const [pasien, setPasien] = useState("")
    const [unitClass, setUnitClass] = useState("")
    const [noRM, setNoRM] = useState("")
    const [bookingID, setBookingID] = useState("")
    const [perkiraanKM, setPerkiraanKM] = useState("")
    const [address, setAddress] = useState("")
    const [distance, setDistance] = useState("")
    const [kategori, setKategori] = useState("")
    const [orderType, setOrderType] = useState("")
    const [status, setStatus] = useState("")
    const [via, setVia] = useState("")
    const [ketAlamat, setKetAlamat] = useState("")
    const [notes, setNotes] = useState("");

    const [dataAmbulance, setDataAmbulance] = useState([])
    const [ambulance, setAmbulance] = useState(null)

    const [perawat, setPerawat] = useState("-")
    const [dataPerawat, setDataPerawat] = useState([])

    const [dataSupir, setDataSupir] = useState([])
    const [supir, setSupir] = useState("-")

    const [dokter, setDokter] = useState("-")
    const [dataDokter, setDataDokter] = useState([])


    const [price, setPrice] = useState("")
    const [createAt, setCreateAt] = useState(new Date());
    const [updateAt, setUpdateAt] = useState(new Date());
    const [createBy, setCreateBy] = useState("");
    const [updateBy, setUpdateBy] = useState("");

    const [errorPemesan, setErrorPemesan] = React.useState(false);
    const [errorPasien, setErrorPasien] = React.useState(false);
    const [errorHP, setErrorHP] = React.useState(false)

    const [texterrorPemesan, setTextErrorPemesan] = React.useState(null);
    const [texterrorPasien, setTextErrorPasien] = React.useState(null);
    const [texterrorHP, setTextErrorHP] = React.useState(null)


    const [jamBerangkat, setJamBerangkat] = useState("");
    const [jamPulang, setJamPulang] = useState("");
    const [berangkatActual, setBerangkatActual] = useState("");
    const [pulangActual, setPulangActual] = useState("");
    const [visibleMap, setvisibleMap] = React.useState(false);
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        getAmbulance()
        console.log(props);
    }, []);

    const getAmbulance = () => {
        api.create().getAmbulance().then(response => {
            console.log(response);
            if (response.data) {
                let dataAmbulance = []
                response.data.data.map(item => {
                    dataAmbulance.push({
                        id: item.id,
                        value: `${item.vehicle_name} - ${item.vehicle_number}`
                    })
                })
                setDataAmbulance(dataAmbulance)
                getDetail(dataAmbulance)
            }
        })
    }

    const getListPetugas = (supir, perawat) => {
        api.create().getListPetugas().then(response => {
            console.log(response);
            if (response.data) {
                let dataSupir = []
                let dataPerawat = []
                response.data.data.map(item => {
                    if (item.role === "Supir") {
                        dataSupir.push({
                            id: item.id,
                            value: item.name
                        })
                    } else if (item.role === "Perawat") {
                        dataPerawat.push({
                            id: item.id,
                            fullname: item.name
                        })
                    }
                })
                console.log(supir);
                if (supir) {
                    let idxSupir = dataSupir.findIndex((val) => val.id === supir.id)
                    if (idxSupir > -1) {
                        setSupir(dataSupir[idxSupir])
                    }
                }
                setPerawat(perawat)
                setDataSupir(dataSupir)
                setDataPerawat(dataPerawat)
            }
        })
    }

    const getDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                let dataDokter = []
                response.data.data.map(item => {
                    if (item.deleted_at === null) {
                        if (item.is_igd === 1) {
                            dataDokter.push({
                                id: item.id,
                                name: item.name
                            })
                        }
                    }
                })
                setDataDokter(dataDokter)
            }
        })
    }


    const getDetail = (cat) => {
        // console.log(location);
        api.create().getDetailEmergency(props.rowData[8]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    // setTglOrder(new Date(data.created_at))
                    setPemesan(data.customer_name)
                    setNoHP(data.phone_number)
                    setPasien(data.patient_name)
                    setNoRM(data.medical_record_no === "" ? "-" : data.medical_record_no)
                    setBookingID(data.booking_id)
                    setPerkiraanKM(`${Number(Number(data.estimated_mileage) / 1000).toFixed(1)} km`)
                    setAddress(data.address)
                    setKategori(data.order_category_name)
                    setCreateAt(new Date(data.created_at))
                    setUpdateAt(new Date(data.updated_at))
                    setCreateBy(data.created_by)
                    setUpdateBy(data.updated_by === null ? '-' : data.updated_by)
                    setVia(data.order_via_name)
                    setAmbulance(data.ambulance)
                    setStatus(data.status_name)
                    setUnitClass(data.class_unit === "" ? "-" : data.class_unit)
                    setPrice(data.estimated_price)
                    setOrderType(data.order_type_name)
                    setJamBerangkat(data.estimated_departure_time === null ? "-" : format(new Date(`2014-08-18T${data.estimated_departure_time}`), 'HH:mm:ss'))
                    setJamPulang(data.estimated_return_time === null ? "-" : format(new Date(`2014-08-18T${data.estimated_return_time}`), 'HH:mm:ss'))
                    setBerangkatActual(data.actual_departure_time === null ? "-" : format(new Date(`2014-08-18T${data.actual_departure_time}`), 'HH:mm:ss'))
                    setPulangActual(data.actual_return_time === null ? "-" : format(new Date(`2014-08-18T${data.actual_return_time}`), 'HH:mm:ss'))
                    setJamBooking(data.booking_time === null ? "-" : format(new Date(`2014-08-18T${data.booking_time}`), 'HH:mm:ss'))
                    setTglBooking(new Date(data.booking_date))
                    setKetAlamat(data.address_notes === "" ? "-" : data.address_notes === null ? "-" : data.address_notes)
                    setNotes(data.notes === "" ? "-" : data.notes === null ? "-" : data.notes)
                    let nurse = []
                    if (data.nurse_emergency_user) {
                        data.nurse_emergency_user.map(item => {
                            nurse.push(item.fullname)
                        })
                    }
                    setPerawat(nurse.length > 0 ? nurse.join(`, `) : "-")
                    if (data.driver_emergency_user) {
                        setSupir(data.driver_emergency_user.fullname)
                    }
                    
                    let dokters = []
                    if (data.doctor) {
                        data.doctor.map(item => {
                            dokters.push(item.name)
                        })
                    }
                    setDokter(dokters.length > 0 ? dokters.join(`, `) : "-")
                    forceUpdate()
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    return (

        <div className="App app-popup-show">
            <div className="popup-content-full background-white">
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail History - Emergency</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={statusAlert}>
                        {messageAlert}
                    </Alert>
                </Snackbar>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        <Typography style={{ marginLeft: 25, marginTop: 20, textAlign: 'left', color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Data Pemesan</Typography>
                        <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 60 }}>
                            {/* <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        value={tglOrder}
                                        readOnly={true}
                                        label="Tanggal & Jam Order"
                                        onError={console.log}
                                        // minDate={new Date()}
                                        ampm={false}
                                        format="dd/MM/yyyy  HH:mm "
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div> */}
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Nama Pemesan"
                                        value={pemesan}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2">
                                <div>
                                    <TextField
                                        style={{ width: '100%' }}
                                        label="No. Handphone"
                                        value={noHP || "-"}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                color: 'black'
                                            }
                                        }}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                            // maxLength: 12,
                                            // startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5, fontSize: 14, }}>+62</InputAdornment>,
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Nama Pasien"
                                        value={pasien}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="No RM"
                                        value={noRM}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <Typography style={{ marginLeft: 25, marginTop: 20, textAlign: 'left', color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Pesanan</Typography>
                        <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 60 }}>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Kode Booking"
                                        value={bookingID}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Kategori Pesanan"
                                        value={kategori}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Tanggal Pesanan"
                                        value={format(new Date(tglBooking), 'yyyy-MM-dd')}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="column-2" style={{ width: '90%' }}>
                                <TextField
                                    label="Jam Pesanan"
                                    value={jamBooking}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>

                            <div className="column-1" style={{ width: '90%' }}>
                                <div style={{ display: 'flex' }}>
                                    <TextField
                                        label="Lokasi"
                                        value={address}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        multiline={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>

                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Perkiraan KM"
                                        value={perkiraanKM}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Keterangan Alamat"
                                        value={ketAlamat}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <Typography style={{ marginLeft: 25, marginTop: 20, textAlign: 'left', color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Konfirmasi</Typography>
                        <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 60 }}>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Jenis Pesanan"
                                        value={orderType}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Unit/Kelas"
                                        value={unitClass}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Mobil Ambulance"
                                        value={ambulance === null ? "-" : `${ambulance.vehicle_name} - ${ambulance.vehicle_number}`}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    {/* <Autocomplete
                                    options={dataAmbulance}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setAmbulance(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Mobil Ambulance'}
                                        />
                                    }
                                    value={ambulance}
                                /> */}
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Perkiraan Harga"
                                        value={price}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    {/* <CustomTextField
                                    value={price}
                                    label="Perkiraan Harga"
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                    onChange={(val) => {
                                        setPrice(val)
                                        forceUpdate()
                                    }}
                                /> */}
                                </div>
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <TextField
                                    label="Perkiraan Jam Berangkat"
                                    value={jamBerangkat}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <TextField
                                    label="Perkiraan Jam Pulang"
                                    value={jamPulang}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Jam Berangkat Actual"
                                        value={berangkatActual}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Jam Pulang Actual"
                                        value={pulangActual}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>


                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Status"
                                        value={status}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Catatan Lainnya"
                                        value={notes}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <Typography style={{ marginLeft: 25, marginTop: 20, textAlign: 'left', color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Petugas</Typography>
                        <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 60 }}>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Perawat"
                                        value={perawat}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Supir"
                                        value={supir}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Dokter"
                                        value={dokter}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>  
                            </div>
                        </div>
                        <Typography style={{ marginLeft: 25, marginTop: 20, textAlign: 'left', color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Status</Typography>
                        <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 60 }}>
                            <div className="column-1" style={{ width: '90%' }}>
                                <TextField
                                    label="Created Date"
                                    value={format(new Date(createAt), 'yyyy-MM-dd HH:mm:ss')}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <TextField
                                    label="Created By"
                                    value={createBy}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <TextField
                                    label="Updated Date"
                                    value={format(new Date(updateAt), 'yyyy-MM-dd HH:mm:ss')}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2" style={{ width: '90%' }}>
                                <TextField
                                    label="Updated By"
                                    value={updateBy}
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        },
                                        disableUnderline: true
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 18,
                                            color: '#7e8085',
                                            fontWeight: '500'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-1" style={{ width: '90%' }}>
                                <div>
                                    <TextField
                                        label="Order By"
                                        value={via}
                                        style={{ width: '100%' }}
                                        disabled={true}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            disableUnderline: true
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 18,
                                                color: '#7e8085',
                                                fontWeight: '500'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}